import type { Edge, Node } from '@/types/node';

export enum SubflowTemplateType {
  SavedModel = 'saved_model',
  SavedNode = 'saved_node',
  Subflow = 'subflow',
}

export interface SubflowTemplateData {
  nodes: Node[];
  edges?: Edge[];
}

export interface CreateSubflowTemplateRequestDto {
  type: SubflowTemplateType;
  name: string;
  description?: string;
  data: SubflowTemplateData;
  icon?: string;
  thumbnail?: string;
  sourceNodeDefinitionId?: string;
}

export interface EditSubflowTemplateRequestDto {
  name?: string;
  description?: string;
  icon?: string;
  thumbnail?: string;
}

export interface SubflowTemplateResponseDto {
  id: string;
  workspaceId: string;
  type: SubflowTemplateType;
  createdBy: string;
  name: string;
  description?: string;
  data?: SubflowTemplateData;
  icon?: string;
  thumbnail?: string;
  sourceNodeDefinitionId?: string;
  createdAt: string;
  updatedAt: string;
}

export interface ListSubflowTemplatesResponseDto {
  workspaceSubflowTemplates: SubflowTemplateResponseDto[];
}
